<template>
    <div class="alert-selector">
        <p class="alert-selector-title">{{title}}</p>
        <el-select class="alert-selector-content" v-model="localValue" placeholder="请选择" :popper-append-to-body="false">
            <el-option v-for="item in dataArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    model: {
        prop: "value",
        event: "input"
    },

    props: {
        title: String,
        value: [Number, String],
        dataArray: Array,
        modeType: Number,
    },

    data() {
        return {
            localValue: this.value || this.modeType || ''
        }
    },

    mounted() {
        // 优先使用传入的 value，其次是 modeType
        if (this.value !== undefined && this.value !== null) {
            this.localValue = this.value;
        } else if (this.modeType !== undefined && this.modeType !== null) {
            this.localValue = this.modeType;
        }
    },

    watch: {
        value(newVal) {
            if (newVal !== undefined && newVal !== null) {
                this.localValue = newVal;
            }
        },

        localValue(value) {
            this.$emit("input", value);
        }
    }
}
</script>

<style lang="scss" scoped>


.alert-selector {
    background-color: #F6F6F6;
    box-sizing: border-box;
    width: rem(260);
    height: rem(44);
    padding-left: rem(10);
    border-radius: rem(6);

    display: flex;
    align-items: center;

    &-title {
        color: #444C72;
        font-size: rem(14);
        margin-right: rem(15);
    }

    &-content {
        margin-top: rem(2);
        width: rem(172);

        /deep/.el-input__inner {
            background-color: #F6F6F6;
            border-color: transparent !important;
            width: 100%;
        }

        /deep/.el-select__caret {
            color: #444C72
        }

        /deep/.el-select-dropdown el-popper {
            @include z-index-max;
        }

        /deep/.el-select-dropdown__item {
            font-size: rem(14);
            box-sizing: border-box;
            padding-left: rem(20);
        }

        /deep/.el-select-dropdown__item.selected {
            color: #325FAC;
        }
    }
}
</style>